import { render, staticRenderFns } from "./composantVisualisationFacture.vue?vue&type=template&id=4fa85200&scoped=true"
import script from "./composantVisualisationFacture.vue?vue&type=script&lang=js"
export * from "./composantVisualisationFacture.vue?vue&type=script&lang=js"
import style0 from "./composantVisualisationFacture.vue?vue&type=style&index=0&id=4fa85200&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa85200",
  null
  
)

export default component.exports